<template>
  <div id="app" class="space">
		<router-view v-show="showContent"/>
		<spinner v-if="showSpinner"/>
  </div>
</template>

<script>
export default {
	name: 'App',
	computed: {
		showContent () {
			return this.$store.state.ui.showContent;
		},
		showSpinner () {
			return this.$store.state.ui.showSpinner;
		}
	}
};
</script>

<style lang="scss">
@import "./scss/global.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue